"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.GA4_TRIGGERS = void 0;
var bookingComplete = function bookingComplete(booking) {
  var _booking$mainOrder$or, _booking$mainOrder, _booking$mainOrder2, _booking$week, _booking$week2, _booking$package, _booking$mainOrder$or2, _booking$mainOrder3, _booking$week3, _booking$week4, _booking$mainOrder4, _booking$package2, _booking$week5, _booking$week6;
  if (!booking) return;
  // E-commerce event
  var promoCodeOrderItem = (_booking$mainOrder$or = booking.mainOrder.orderItems) === null || _booking$mainOrder$or === void 0 ? void 0 : _booking$mainOrder$or.find(function (item) {
    return +item.productVariant.product.id == 17;
  });
  var discount = promoCodeOrderItem && (promoCodeOrderItem === null || promoCodeOrderItem === void 0 ? void 0 : promoCodeOrderItem.gross) * -1; // discount comes as negative value
  var inputString = promoCodeOrderItem && (promoCodeOrderItem === null || promoCodeOrderItem === void 0 ? void 0 : promoCodeOrderItem.description);
  // quick and dirty way to get promocode from the description string
  var regex = /code:(\w+)/;
  var match = inputString && regex.exec(inputString);
  var coupon = match && match[1] || null;
  var ecommerceDataObject = {
    event: 'purchase',
    ecommerce: {
      transaction_id: booking.id,
      tax: null,
      shipping: null,
      currency: (_booking$mainOrder = booking.mainOrder) === null || _booking$mainOrder === void 0 ? void 0 : _booking$mainOrder.currency,
      value: ((_booking$mainOrder2 = booking.mainOrder) === null || _booking$mainOrder2 === void 0 ? void 0 : _booking$mainOrder2.gross) / 100,
      coupon: coupon,
      items: [{
        item_id: (_booking$week = booking.week) === null || _booking$week === void 0 || (_booking$week = _booking$week.destination) === null || _booking$week === void 0 ? void 0 : _booking$week.id,
        item_name: (_booking$week2 = booking.week) === null || _booking$week2 === void 0 || (_booking$week2 = _booking$week2.destination) === null || _booking$week2 === void 0 ? void 0 : _booking$week2.name,
        affiliation: null,
        coupon: coupon,
        discount: discount,
        index: 0,
        item_brand: null,
        item_category: booking.week.week,
        item_category2: ((_booking$package = booking["package"]) === null || _booking$package === void 0 ? void 0 : _booking$package.name) || 'Custom Yacht',
        item_category3: booking.subject,
        item_category4: booking.needHostess ? 'Host' : null,
        item_category5: (_booking$mainOrder$or2 = booking.mainOrder.orderItems) === null || _booking$mainOrder$or2 === void 0 ? void 0 : _booking$mainOrder$or2.some(function (item) {
          var _item$productVariant;
          return +((_item$productVariant = item.productVariant) === null || _item$productVariant === void 0 || (_item$productVariant = _item$productVariant.product) === null || _item$productVariant === void 0 ? void 0 : _item$productVariant.id) == 18;
        }),
        item_list_id: "destinations",
        item_list_name: "Destinations",
        item_variant: (booking.numGirls || 0) + (booking.numBoys || 0),
        location_id: null,
        price: ((_booking$mainOrder3 = booking.mainOrder) === null || _booking$mainOrder3 === void 0 ? void 0 : _booking$mainOrder3.gross) / 100,
        quantity: 1
      }]
    }
  };
  handeEventPush(ecommerceDataObject);

  // Custom GA4 event
  var eventDataObject = {
    event: 'booking_complete',
    booker_id: booking.booker.id,
    booker_email: booking.booker.email,
    week: (_booking$week3 = booking.week) === null || _booking$week3 === void 0 ? void 0 : _booking$week3.week,
    financial_year: (_booking$week4 = booking.week) === null || _booking$week4 === void 0 ? void 0 : _booking$week4.year,
    promo_code: booking.promoCode,
    main_order_gross: ((_booking$mainOrder4 = booking.mainOrder) === null || _booking$mainOrder4 === void 0 ? void 0 : _booking$mainOrder4.gross) / 100,
    main_order_currency: booking.mainOrder.currency,
    booking_subject: booking.subject,
    booking_type: booking.type,
    package_name: ((_booking$package2 = booking["package"]) === null || _booking$package2 === void 0 ? void 0 : _booking$package2.name) || 'Custom yacht',
    destination_name: (_booking$week5 = booking.week) === null || _booking$week5 === void 0 ? void 0 : _booking$week5.destination.name,
    destination_id: (_booking$week6 = booking.week) === null || _booking$week6 === void 0 ? void 0 : _booking$week6.destination.id
  };
  handeEventPush(eventDataObject);
};
var contactSubscribe = function contactSubscribe(_ref) {
  var firstName = _ref.firstName,
    lastName = _ref.lastName,
    email = _ref.email;
  return handeEventPush({
    event: 'contact_subscribe',
    subscriber: true,
    first_name: firstName,
    last_name: lastName,
    email: email
  });
};
var joinWaitingList = function joinWaitingList(_ref2) {
  var destination = _ref2.destination,
    week = _ref2.week,
    email = _ref2.email;
  return handeEventPush({
    event: 'join_waiting_list',
    subscriber: true,
    destination_name: destination,
    week: week,
    email: email
  });
};
var signup = function signup(_ref3) {
  var id = _ref3.id,
    email = _ref3.email;
  return handeEventPush({
    event: 'sign_up',
    subscriber: true,
    user_id: id,
    email: email
  });
};
var beginCheckout = function beginCheckout(booking) {
  var _booking$mainOrder5, _booking$package3, _booking$mainOrder$or3, _booking$mainOrder6, _booking$mainOrder7, _booking$package4;
  // Custom GA4 event
  // E-commerce event
  // (in this case ecommerce is same event as the one with custom properties)
  var ecommerceDataObject = {
    event: 'begin_checkout',
    ecommerce: {
      currency: booking.mainOrder.currency,
      value: ((_booking$mainOrder5 = booking.mainOrder) === null || _booking$mainOrder5 === void 0 ? void 0 : _booking$mainOrder5.gross) / 100,
      coupon: null,
      items: [{
        item_id: booking.week.destination.id,
        item_name: booking.week.destination.name,
        affiliation: null,
        coupon: null,
        discount: null,
        index: 0,
        item_brand: null,
        item_category: booking.week.week,
        item_category2: ((_booking$package3 = booking["package"]) === null || _booking$package3 === void 0 ? void 0 : _booking$package3.name) || 'Custom Yacht',
        item_category3: booking.subject,
        item_category4: booking.needHostess ? 'Host' : null,
        item_category5: (_booking$mainOrder$or3 = booking.mainOrder.orderItems) === null || _booking$mainOrder$or3 === void 0 ? void 0 : _booking$mainOrder$or3.some(function (item) {
          return item.productVariant.product.id == 18;
        }),
        item_list_id: "destinations",
        item_list_name: "Destinations",
        item_variant: (booking.numGirls || 0) + (booking.numBoys || 0),
        location_id: null,
        price: ((_booking$mainOrder6 = booking.mainOrder) === null || _booking$mainOrder6 === void 0 ? void 0 : _booking$mainOrder6.gross) / 100,
        quantity: 1
      }]
    },
    booker_id: booking.booker.id,
    booker_email: booking.booker.email,
    week: booking.week.week,
    financial_year: booking.week.year,
    main_order_gross: ((_booking$mainOrder7 = booking.mainOrder) === null || _booking$mainOrder7 === void 0 ? void 0 : _booking$mainOrder7.gross) / 100,
    main_order_currency: booking.mainOrder.currency,
    booking_subject: booking.subject,
    booking_type: booking.type,
    package_name: ((_booking$package4 = booking["package"]) === null || _booking$package4 === void 0 ? void 0 : _booking$package4.name) || 'Custom yacht',
    destination_name: booking.week.destination.name,
    destination_id: booking.week.destination.id
  };
  handeEventPush(ecommerceDataObject);
};
var createPlan = function createPlan(booking) {
  var _booking$week7, _booking$week8, _booking$package5, _booking$week9, _booking$week10;
  return handeEventPush({
    event: 'create_a_plan',
    booker_id: booking.booker.id,
    booker_email: booking.booker.email,
    week: (_booking$week7 = booking.week) === null || _booking$week7 === void 0 ? void 0 : _booking$week7.week,
    financial_year: (_booking$week8 = booking.week) === null || _booking$week8 === void 0 ? void 0 : _booking$week8.year,
    booking_subject: booking.subject,
    booking_type: booking.type,
    package_name: ((_booking$package5 = booking["package"]) === null || _booking$package5 === void 0 ? void 0 : _booking$package5.name) || 'Custom yacht',
    destination_name: (_booking$week9 = booking.week) === null || _booking$week9 === void 0 ? void 0 : _booking$week9.destination.name,
    destination_id: (_booking$week10 = booking.week) === null || _booking$week10 === void 0 ? void 0 : _booking$week10.destination.id
  });
};
var crewFinderAction = function crewFinderAction(_ref4) {
  var name = _ref4.name,
    email = _ref4.email,
    booking_id = _ref4.booking_id;
  return handeEventPush({
    event: 'crew_finder_actions',
    name: name,
    email: email,
    booking_id: booking_id
  });
};
var enteredBookingFunnel = function enteredBookingFunnel(destinations, showNewFunnel) {
  // only on /browse fire ecommerce with list of destinations - will only pass destiantions when this happens
  if (destinations) {
    var ecommerceDataObject = {
      event: 'view_item_list',
      ecommerce: {
        item_list_id: 'destinations',
        item_list_name: 'Destinations',
        items: destinations.map(function (destination, i) {
          return {
            item_id: destination.id,
            item_name: destination.name,
            affiliation: null,
            coupon: null,
            discount: null,
            index: i,
            item_brand: null,
            item_category: null,
            item_category2: null,
            item_category3: null,
            item_category4: null,
            item_category5: null,
            item_list_id: "destinations",
            item_list_name: "Destinations",
            item_variant: null,
            location_id: null,
            price: null,
            quantity: 1
          };
        })
      }
    };
    handeEventPush(ecommerceDataObject);
  }
  handeEventPush({
    event: 'entered_booking_funnel',
    showNewFunnel: showNewFunnel
  });
};
var clickedHomePageHeaderCTA = function clickedHomePageHeaderCTA() {
  return handeEventPush({
    event: 'clicked_homepage_header'
  });
};
var joinedPlan = function joinedPlan(bookingId) {
  return handeEventPush({
    event: 'joined_a_plan',
    booking_id: bookingId
  });
};
var login = function login(_ref5) {
  var id = _ref5.id,
    email = _ref5.email;
  return handeEventPush({
    event: 'login',
    user_id: id,
    email: email
  });
};
var logout = function logout(_ref6) {
  var id = _ref6.id,
    email = _ref6.email;
  return handeEventPush({
    event: 'logout',
    user_id: id,
    email: email
  });
};
var selectedCrew = function selectedCrew(_ref7) {
  var week = _ref7.week,
    financial_year = _ref7.financial_year,
    subject = _ref7.subject,
    package_name = _ref7.package_name,
    destination_name = _ref7.destination_name,
    destination_id = _ref7.destination_id;
  return handeEventPush({
    event: 'selected_crew',
    week: week,
    financial_year: financial_year,
    subject: subject,
    package_name: package_name,
    destination_name: destination_name,
    destination_id: destination_id
  });
};
var selectedCustomYacht = function selectedCustomYacht(_ref8) {
  var week = _ref8.week,
    financial_year = _ref8.financial_year,
    destination_name = _ref8.destination_name,
    destination_id = _ref8.destination_id;
  return handeEventPush({
    event: 'selected_custom_yacht',
    week: week,
    financial_year: financial_year,
    destination_name: destination_name,
    destination_id: destination_id
  });
};
var selectedDestination = function selectedDestination(_ref9) {
  var destination_name = _ref9.destination_name,
    destination_id = _ref9.destination_id;
  // E-commerce event
  var ecommerceDataObject = {
    event: 'select_item',
    ecommerce: {
      item_list_id: 'destinations',
      item_list_name: 'Destinations',
      items: [{
        item_id: destination_id,
        item_name: destination_name,
        affiliation: null,
        coupon: null,
        discount: null,
        index: 0,
        item_brand: null,
        item_category: null,
        item_category2: null,
        item_category3: null,
        item_category4: null,
        item_category5: null,
        item_list_id: "destinations",
        item_list_name: "Destinations",
        item_variant: null,
        location_id: null,
        price: null,
        quantity: 1
      }]
    }
  };
  handeEventPush(ecommerceDataObject);
  // Custom GA4 event
  handeEventPush({
    event: 'selected_destination',
    destination_name: destination_name,
    destination_id: destination_id
  });
};
var selectedWeek = function selectedWeek(_ref10) {
  var destination_name = _ref10.destination_name,
    destination_id = _ref10.destination_id,
    week = _ref10.week,
    financial_year = _ref10.financial_year;
  return handeEventPush({
    event: 'selected_week',
    destination_name: destination_name,
    destination_id: destination_id,
    week: week,
    financial_year: financial_year
  });
};
var selectedYachtPackage = function selectedYachtPackage(_ref11) {
  var week = _ref11.week,
    financial_year = _ref11.financial_year,
    package_name = _ref11.package_name,
    destination_name = _ref11.destination_name,
    destination_id = _ref11.destination_id;
  return handeEventPush({
    event: 'selected_yacht_package',
    week: week,
    financial_year: financial_year,
    package_name: package_name,
    destination_name: destination_name,
    destination_id: destination_id
  });
};
var sharedPlan = function sharedPlan(_ref12) {
  var booking_id = _ref12.booking_id;
  return handeEventPush({
    event: 'selected_yacht_package',
    booking_id: booking_id
  });
};
var viewedBookingSummary = function viewedBookingSummary(_ref13) {
  var week = _ref13.week,
    financial_year = _ref13.financial_year,
    subject = _ref13.subject,
    package_name = _ref13.package_name,
    destination_name = _ref13.destination_name,
    destination_id = _ref13.destination_id,
    totalPrice = _ref13.totalPrice,
    weekCurrency = _ref13.weekCurrency;
  // E-commerce event
  var ecommerceDataObject = {
    event: 'view_item',
    ecommerce: {
      currency: weekCurrency,
      value: totalPrice,
      items: [{
        item_id: destination_id,
        item_name: destination_name,
        affiliation: null,
        coupon: null,
        discount: null,
        index: 0,
        item_brand: null,
        item_category: week,
        item_category2: package_name,
        item_category3: subject,
        item_category4: null,
        item_category5: null,
        item_list_id: "destinations",
        item_list_name: "Destinations",
        item_variant: null,
        location_id: null,
        price: totalPrice,
        quantity: 1
      }]
    }
  };
  handeEventPush(ecommerceDataObject);

  // Custom GA4 event
  handeEventPush({
    event: 'viewed_booking_summary',
    week: week,
    financial_year: financial_year,
    subject: subject,
    package_name: package_name,
    destination_name: destination_name,
    destination_id: destination_id
  });
};
var selectedDateTimeCalendly = function selectedDateTimeCalendly() {
  var _window;
  var isNavbar = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return handeEventPush({
    event: 'selected_datetime_calendly',
    pathname: (_window = window) === null || _window === void 0 ? void 0 : _window.location.pathname,
    isNavbar: isNavbar
  });
};
var scheduledCalendly = function scheduledCalendly() {
  var _window2;
  var isNavbar = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return handeEventPush({
    event: 'scheduled_calendly',
    pathname: (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.location.pathname,
    isNavbar: isNavbar
  });
};

// ----------------------------------
// Helper functions, serializations
// ----------------------------------
var handeEventPush = function handeEventPush(eventDataObject) {
  var _window3, _window4;
  (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.dataLayer) === null || _window3 === void 0 || _window3.push(nullifyAllProperties(eventDataObject));
  (_window4 = window) === null || _window4 === void 0 || (_window4 = _window4.dataLayer) === null || _window4 === void 0 || _window4.push(eventDataObject);
};
var nullifyAllProperties = function nullifyAllProperties(obj) {
  var nullified = {};
  Object.keys(obj).forEach(function (key) {
    nullified[key] = null;
  });
  return nullified;
};

// some triggers are used in multiple components so cannot risk having duplicated IDs
// naming convention: [triggerName]_[CLASS/ID]
var GA4_TRIGGERS = exports.GA4_TRIGGERS = {
  // Click elements
  BOOK_CALL_CLASS: 'ga4_contact_book_call',
  EMAIL_TEAM_CLASS: 'ga4_contact_email_team',
  WHATSAPP_CLASS: 'ga4_contact_whatsapp',
  JOIN_WAITING_LIST_CLASS: 'ga4_join_waiting_list',
  OPEN_WEEK_DROPDOWN_CLASS: 'ga4_open_week_dropdown',
  ADD_CABIN_CREW_CLASS: 'ga4_add_cabin_crew',
  REMOVE_CABIN_CREW_CLASS: 'ga4_remove_cabin_crew',
  ADD_CREW_CLASS: 'ga4_add_crew',
  REMOVE_CREW_CLASS: 'ga4_remove_crew',
  ADD_HOST_CREW_CLASS: 'ga4_add_host_crew',
  REMOVE_HOST_CREW_CLASS: 'ga4_remove_host_crew',
  ADD_FUNNEL_EXTRA_CLASS: 'ga4_add_funnel_extra',
  REMOVE_FUNNEL_EXTRA_CLASS: 'ga4_remove_funnel_extra',
  CHANGED_CURRENCY_CLASS: 'ga4_changed_currency',
  VIEW_PAYMENT_PLAN_CLASS: 'ga4_view_payment_plan',
  // Form IDs
  BOOK_CALL_FORM_ID: 'ga4_book_call_form',
  CALL_US_FORM_ID: 'ga4_call_us_form',
  GROUP_BOOKINGS_FORM_ID: 'ga4_group_bookings_form',
  SIGNUP_FORM_ID: 'ga4_signup_form',
  PROMOCODE_FORM_ID: 'ga4_promocode_form',
  WAITING_LIST_FORM_ID: 'ga4_waiting_list_form',
  CREW_FINDER_CONTACT_FORM_ID: 'ga4_crew_finder_contact_form',
  INVITATION_CODE_FORM_ID: 'ga4_invitation_code_form',
  UPGRADE_BOOKING_FORM_ID: 'ga4_upgrade_booking_form',
  AGENT_REGISTRATION_FORM_ID: 'ga4_agent_registration_form',
  PARTNERS_FORM_ID: 'ga4_partners_form',
  WHY_FORM_ID: 'ga4_why_form',
  BO_2024_FORM_ID: 'ga4_bo_2024_form'
};
var analytics = {
  bookingComplete: bookingComplete,
  contactSubscribe: contactSubscribe,
  joinWaitingList: joinWaitingList,
  signup: signup,
  beginCheckout: beginCheckout,
  createPlan: createPlan,
  crewFinderAction: crewFinderAction,
  enteredBookingFunnel: enteredBookingFunnel,
  joinedPlan: joinedPlan,
  login: login,
  logout: logout,
  selectedCrew: selectedCrew,
  selectedCustomYacht: selectedCustomYacht,
  selectedDestination: selectedDestination,
  selectedWeek: selectedWeek,
  selectedYachtPackage: selectedYachtPackage,
  sharedPlan: sharedPlan,
  viewedBookingSummary: viewedBookingSummary,
  clickedHomePageHeaderCTA: clickedHomePageHeaderCTA,
  selectedDateTimeCalendly: selectedDateTimeCalendly,
  scheduledCalendly: scheduledCalendly
};
var _default = exports["default"] = analytics;